import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { onCheckLogin } from "@/router/middleware";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layouts/TheLayout.vue"),
    redirect: "/call/list",
    beforeEnter: onCheckLogin,
    children: [
      {
        path: "login",
        component: () => import("@/views/emergency-call/list.vue"),
      },
    ],
  },
  {
    path: "/sign-in",
    component: () => import("@/views/sign-in/SignIn.vue"),
  },
  {
    path: "/call",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/call/list",
        component: () => import("@/views/call/list.vue"),
      },
    ],
  },
  {
    path: "/user",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/user/list",
        component: () => import("@/views/user/list.vue"),
      },
    ],
  },
  {
    path: "/pricing",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/pricing/country/list",
        component: () => import("@/views/pricing/country/list.vue"),
      },
      {
        path: "/pricing/country-pricing/list",
        component: () => import("@/views/pricing/country-pricing/list.vue"),
      },
    ],
  },
  {
    path: "/emergency-call",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/emergency-call/list",
        component: () => import("@/views/emergency-call/list.vue"),
      },
    ],
  },
  {
    path: "/app",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/app/ringtone-list",
        component: () => import("@/views/ringtone/list.vue"),
      },
    ],
  },
  {
    path: "/admin",
    component: () => import("@/layouts/TheLayout.vue"),
    children: [
      {
        path: "/admin/list",
        component: () => import("@/views/admin/list.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 웹뷰 로드 시점에 테스트 메시지 전송
window.addEventListener("load", () => {
  console.log("Window loaded, sending test message");
  window.postMessage(
    {
      schema: "usimsa:flutter",
      path: "test-message",
      type: "init",
    },
    "*"
  );
});

router.afterEach((to) => {
  if (window.FlutterWebView) {
    window.FlutterWebView.postMessage(
      JSON.stringify({
        schema: "usimsa:flutter",
        path: to.fullPath,
      })
    );
  }
});

export default router;
